import type { ChangeRequestStatus, ChangeRequestType } from './types';
import type { IsoStandard } from '../../constants/isoStandards';

export const CHANGE_TYPE_LABEL: Record<ChangeRequestType, string> = {
  proceso: 'Proceso',
  documento: 'Documento',
  infraestructura: 'Infraestructura',
  tecnologico: 'Tecnológico',
  organizacional: 'Organizacional',
  otro: 'Otro',
};

export const STATUS_LABEL: Record<ChangeRequestStatus, string> = {
  propuesto: 'Propuesto',
  en_evaluacion: 'En evaluación',
  aprobado: 'Aprobado',
  rechazado: 'Rechazado',
  implementado: 'Implementado',
  cerrado: 'Cerrado / verificado',
};

export const STANDARD_LABEL: Record<IsoStandard, string> = {
  iso9001: 'ISO 9001',
  iso14001: 'ISO 14001',
  iso27001: 'ISO 27001',
  iso45001: 'ISO 45001',
};

export const NEXT_STATUS: Partial<Record<ChangeRequestStatus, ChangeRequestStatus>> = {
  propuesto: 'en_evaluacion',
  en_evaluacion: 'aprobado',
  aprobado: 'implementado',
  implementado: 'cerrado',
};

export const NEXT_STATUS_ACTION: Partial<Record<ChangeRequestStatus, string>> = {
  propuesto: 'Enviar a evaluación',
  en_evaluacion: 'Aprobar',
  aprobado: 'Marcar implementado',
  implementado: 'Verificar y cerrar',
};

export function statusBadgeClass(status: ChangeRequestStatus): string {
  if (status === 'cerrado') return 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-200';
  if (status === 'aprobado' || status === 'implementado') {
    return 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200';
  }
  if (status === 'en_evaluacion') {
    return 'bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-200';
  }
  if (status === 'rechazado') {
    return 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200';
  }
  return 'bg-muted text-muted-foreground';
}

export function typeBadgeClass(changeType: ChangeRequestType): string {
  if (changeType === 'documento') return 'bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-200';
  if (changeType === 'infraestructura' || changeType === 'tecnologico') {
    return 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-200';
  }
  return 'bg-muted text-muted-foreground';
}
